module.exports = __webpack_public_path__ + "static/media/internship-avatar-testimonies-2.a81ccb4c.png";